
import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Textarea } from '@/components/ui/textarea';

interface NewProviderModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export const NewProviderModal: React.FC<NewProviderModalProps> = ({ open, onOpenChange }) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Nuevo Proveedor</DialogTitle>
        </DialogHeader>
        <div className="space-y-4">
          <div>
            <Label htmlFor="nombre">Nombre del proveedor</Label>
            <Input id="nombre" placeholder="Ej: Catering Delicious" />
          </div>
          <div>
            <Label htmlFor="tipo">Tipo de servicio</Label>
            <Select>
              <SelectTrigger>
                <SelectValue placeholder="Selecciona un tipo" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="catering">Catering</SelectItem>
                <SelectItem value="fotografia">Fotografía</SelectItem>
                <SelectItem value="decoracion">Decoración</SelectItem>
                <SelectItem value="musica">Música</SelectItem>
                <SelectItem value="transporte">Transporte</SelectItem>
              </SelectContent>
            </Select>
          </div>
          <div>
            <Label htmlFor="telefono">Teléfono</Label>
            <Input id="telefono" placeholder="+52 55 1234 5678" />
          </div>
          <div>
            <Label htmlFor="email">Email</Label>
            <Input id="email" type="email" placeholder="info@proveedor.com" />
          </div>
          <div>
            <Label htmlFor="notas">Notas (opcional)</Label>
            <Textarea id="notas" placeholder="Información adicional..." rows={3} />
          </div>
          <div className="flex justify-end space-x-2 pt-4">
            <Button variant="outline" onClick={() => onOpenChange(false)}>
              Cancelar
            </Button>
            <Button className="bg-blue-600 hover:bg-blue-700 text-white">
              Guardar Proveedor
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
